// extracted by mini-css-extract-plugin
export default {"iconSize-s":"iconSize-s-14f76","iconSize-m":"iconSize-m-14f76","iconSize-l":"iconSize-l-14f76","disabled":"disabled-14f76","shine":"shine-14f76"};